<template>
    <el-table-column
      align="left"
    >
      <template slot="header">
        <div>Уровни - это детализация цели.</div>
        <div>Необходимо выбрать уровни вручную.</div>
      </template>

      <el-table-column
        v-for="partIndex in 3"
        :key="partIndex"
        :label="partLabels[partIndex]"
        width="150"
      >
        <template v-slot="scope">
          <element-scale-part-single-table-column
            :scope="scope"
            :disabled="!isFieldAvailableForEdit(scope.row, 'scale.current_part_id')"
            :initial="partIndex===1"
            :part-name="'part_'+partIndex"
            @save-current_part_id="saveCurrentPart(scope, $event)"
          >
          </element-scale-part-single-table-column>
        </template>
      </el-table-column>


    </el-table-column>

</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import ElementScalePartSingleTableColumn
  from "@/componentsCompany/cherkizovo/tableColumnTemplates/card/parts/ElementScalePartSingleTableColumn.vue";

export default {
  name: 'element-scale-part-top-table-column',
  components: {ElementScalePartSingleTableColumn, ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  computed: {},
  beforeMount() {

  },
  data() {
	  return {
      partLabels: {
        1: 'Уровень 1 (канал, направление)',
        2: 'Уровень 2 (площадка, регион)',
        3: 'Уровень 3 (сегмент, продукт)'
      }
    }
  },
  mounted() {

  },
  methods: {
    saveCurrentPart(scope, chosenPartId){
      this.saveElementPropChange(scope.row, 'scale', {current_part_id:chosenPartId})
    },
  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
